import { useNavigate } from 'react-router-dom';
import { Button } from '@plush-book/ui';

export function IPError() {
  const nav = useNavigate();
  return (
    <div className="shell">
      <div
        style={{
          padding: '14px 18px 12px',
          background: 'var(--bg-card)',
          borderBottom: '1px solid var(--line-soft)',
        }}
      >
        <button
          onClick={() => nav('/plush')}
          style={{
            background: 'transparent',
            border: 0,
            fontSize: 11,
            color: 'var(--ink-mute)',
            fontFamily: 'var(--mono)',
            cursor: 'pointer',
          }}
        >
          ← KUSCHELTIER PRÜFEN
        </button>
      </div>
      <div
        style={{
          flex: 1,
          padding: '30px 24px',
          background: 'var(--bg)',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 560,
          margin: '0 auto',
          width: '100%',
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 18,
              background: 'var(--terracotta)',
              display: 'grid',
              placeItems: 'center',
              color: '#fff',
              fontSize: 28,
              marginBottom: 22,
              fontWeight: 700,
            }}
          >
            !
          </div>
          <h2
            style={{
              fontFamily: 'var(--serif)',
              fontSize: 26,
              fontWeight: 500,
              margin: 0,
              lineHeight: 1.15,
              letterSpacing: -0.3,
            }}
          >
            Dieses Kuscheltier sieht nach einer bekannten Figur aus.
          </h2>
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.6,
              color: 'var(--ink-soft)',
              marginTop: 14,
            }}
          >
            Damit wir dein Buch sicher und rechtlich sauber erstellen können, verwende bitte ein
            eigenes Kuscheltier ohne Bezug zu bekannten Filmen, Serien, Games oder Marken.
          </p>
        </div>
        <Button variant="primary" size="md" fullWidth onClick={() => nav('/plush')}>
          Anderes Kuscheltier hochladen
        </Button>
        <button
          onClick={() => nav('/')}
          style={{
            width: '100%',
            background: 'transparent',
            color: 'var(--ink-soft)',
            border: 0,
            padding: '10px',
            fontSize: 13,
            marginTop: 4,
            cursor: 'pointer',
          }}
        >
          Hilfe & FAQ
        </button>
      </div>
    </div>
  );
}
